import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const NavLinkAdapter = forwardRef(({ button, innerRef, ...props }, ref) => (
	<NavLink ref={ref} {...props} />
));

NavLinkAdapter.propTypes = {
  button: PropTypes.any,
  innerRef: PropTypes.any,
};

export default NavLinkAdapter;
